// receiptNo is stored inconsistently: older/imported donations have the
// raw receipt number (e.g. "35119"), while newer ones are saved with the
// receipt's year prepended (e.g. "202635119") to keep the number unique
// across years. Storage needs that prefix; users never should see it.
// This strips it back off for display, matching the record's own
// receiptDate year so it doesn't touch numbers that were never prefixed.
export const normalizeReceiptNoForDisplay = (receiptNo, receiptDate) => {
  const receiptNoStr = String(receiptNo ?? "");
  const year = receiptDate
    ? new Date(receiptDate).getFullYear().toString()
    : "";
  return year && receiptNoStr.startsWith(year)
    ? receiptNoStr.slice(year.length)
    : receiptNoStr;
};
